import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "board-panel"
};
var _hoisted_2 = {
  class: "main"
};
import SideBar from './common/SideBar';
import CanvasPanel from './common/CanvasPanel/index';
import CanvasTool from './common/CanvasTool/index';
import ChangeRole from './common/ChangeRole';
import Paging from './common/Paging';

/* 工具 */
import { ref, onMounted, inject, computed } from 'vue';
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store';
import { operationRecord } from './common/common';

/* api */
import { getBoard, addEditBoard, delBoard } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'Board',
  setup: function setup(__props) {
    var _getStore;
    /* 组件 */
    var userId = (_getStore = getStore({
      name: 'userInfo'
    })) === null || _getStore === void 0 ? void 0 : _getStore.id;
    var discussId = inject('discussId');
    var canvasPanelRef = ref(null);
    var canvasObj = ref({});
    var userCanvasList = ref([]); // 当前用户视角下的画布列表
    var current = ref(0); // 当前页码
    var roleId = ref(userId);

    /* 计算属性 */
    // 当前角色是否为自己
    var isMineCanvas = computed(function () {
      return userId === roleId.value;
    });

    /* 事件 */
    // 画布工具切换
    var toolChange = function toolChange(toolInfo) {
      var _canvasPanelRef$value;
      (_canvasPanelRef$value = canvasPanelRef.value) === null || _canvasPanelRef$value === void 0 || _canvasPanelRef$value.toolChange(toolInfo);
    };

    // 画布内容改变
    var canvasChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
        var txt;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!isMineCanvas) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return saveCanvas();
            case 1:
              txt = '';
              if (data.optType === 'penciladd') {
                txt = '白板—使用画笔';
              } else if (data.optType === 'textadd') {
                txt = '白板—使用文本框';
              } else if (data.optType === 'pencildel' || data.optType === 'textdel') {
                txt = '白板—使用橡皮擦';
              }
              txt && operationRecord(discussId.value, txt);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function canvasChange(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    // 绘制画布内容
    var drawCanvas = function drawCanvas(content) {
      var _canvasObj$value;
      (_canvasObj$value = canvasObj.value) === null || _canvasObj$value === void 0 || _canvasObj$value.clear();
      if (content) {
        var _canvasObj$value2, _canvasObj$value3;
        var json = JSON.parse(content);
        (_canvasObj$value2 = canvasObj.value) === null || _canvasObj$value2 === void 0 || _canvasObj$value2.loadFromJSON(json, (_canvasObj$value3 = canvasObj.value) === null || _canvasObj$value3 === void 0 ? void 0 : _canvasObj$value3.renderAll.bind(canvasObj.value));
      }
    };

    // 切换上/下一页
    var switchPage = function switchPage() {
      _getCanvas(roleId.value, current.value);
    };

    // 切换角色
    var roleChange = function roleChange(item) {
      var _canvasPanelRef$value2;
      (_canvasPanelRef$value2 = canvasPanelRef.value) === null || _canvasPanelRef$value2 === void 0 || _canvasPanelRef$value2.cancelTool();
      _getCanvas(item.id);
    };

    // 点击新增画布
    var addPage = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _userCanvasList$value;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return addCanvas();
            case 1:
              _getCanvas(userId, ((_userCanvasList$value = userCanvasList.value) === null || _userCanvasList$value === void 0 ? void 0 : _userCanvasList$value.length) + 1);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function addPage() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 点击删除画布
    var removePage = function removePage() {
      var dialog = DialogPlugin({
        header: '删除',
        body: '是否删除当前页？',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
            var _userCanvasList$value2;
            var canvasId;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  canvasId = (_userCanvasList$value2 = userCanvasList.value[current.value - 1]) === null || _userCanvasList$value2 === void 0 ? void 0 : _userCanvasList$value2.id;
                  delBoard(discussId.value, canvasId).then(function (res) {
                    if (res.data.code === 0) {
                      MessagePlugin.success('删除成功！');
                      _getCanvas();
                      dialog.destroy();
                    }
                  });
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    };

    // 添加画布
    var addCanvas = function addCanvas() {
      return new Promise(function (resolve) {
        var data = {
          userId: userId,
          discussId: discussId.value,
          content: ''
        };
        addEditBoard(data).then(function (res) {
          var _res$data;
          if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 0) {
            resolve();
          }
        });
      });
    };

    // 保存画布
    var saveCanvas = function saveCanvas() {
      return new Promise(function (resolve) {
        var _userCanvasList$value3, _canvasPanelRef$value3;
        var canvasId = (_userCanvasList$value3 = userCanvasList.value[current.value - 1]) === null || _userCanvasList$value3 === void 0 ? void 0 : _userCanvasList$value3.id;
        var data = {
          id: canvasId,
          userId: userId,
          discussId: discussId.value,
          content: (_canvasPanelRef$value3 = canvasPanelRef.value) === null || _canvasPanelRef$value3 === void 0 ? void 0 : _canvasPanelRef$value3.getCanvasJsonStr()
        };
        addEditBoard(data).then(function (res) {
          var _res$data2;
          if (((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === 0) {
            resolve();
          }
        });
      });
    };

    // 获取画布内容 drawLast:是否更新最后一张画布内容
    var _getCanvas = function getCanvas() {
      var uid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userId;
      var page = arguments.length > 1 ? arguments[1] : undefined;
      return new Promise(function (resolve) {
        userCanvasList.value = [];
        getBoard(discussId.value, uid).then(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
            var _res$data3, list, _list, content;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  if (!(res.data.code === 0)) {
                    _context4.n = 3;
                    break;
                  }
                  list = ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data) || [];
                  userCanvasList.value = list;
                  if (!(list.length === 0 && uid === userId)) {
                    _context4.n = 2;
                    break;
                  }
                  _context4.n = 1;
                  return addCanvas();
                case 1:
                  _context4.n = 2;
                  return _getCanvas();
                case 2:
                  if (list.length > 0) {
                    content = page ? (_list = list[page - 1]) === null || _list === void 0 ? void 0 : _list.content : list[0].content;
                    drawCanvas(content);
                    current.value = page ? page : 1;
                  } else {
                    drawCanvas();
                    current.value = 0;
                  }
                  resolve();
                case 3:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }());
      });
    };

    /* 钩子 */
    onMounted(function () {
      _getCanvas();
    });
    return function (_ctx, _cache) {
      var _userCanvasList$value4;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(CanvasPanel), {
        ref_key: "canvasPanelRef",
        ref: canvasPanelRef,
        canvasObj: canvasObj.value,
        "onUpdate:canvasObj": _cache[0] || (_cache[0] = function ($event) {
          return canvasObj.value = $event;
        }),
        onChange: canvasChange
      }, null, 8, ["canvasObj"]), isMineCanvas.value ? (_openBlock(), _createBlock(_unref(CanvasTool), {
        key: 0,
        class: "tool",
        tools: ['brush', 'rubber', 'text', 'clean', 'save'],
        onChange: toolChange
      })) : _createCommentVNode("", true), _createVNode(_unref(ChangeRole), {
        modelValue: roleId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return roleId.value = $event;
        }),
        onChange: roleChange
      }, null, 8, ["modelValue"]), _createVNode(_unref(Paging), {
        class: _normalizeClass({
          'fixed-center': !isMineCanvas.value
        }),
        current: current.value,
        "onUpdate:current": _cache[2] || (_cache[2] = function ($event) {
          return current.value = $event;
        }),
        total: (_userCanvasList$value4 = userCanvasList.value) === null || _userCanvasList$value4 === void 0 ? void 0 : _userCanvasList$value4.length,
        justSwitch: !isMineCanvas.value,
        onSwitchPage: switchPage,
        onAddPage: addPage,
        onRemovePage: removePage
      }, null, 8, ["class", "current", "total", "justSwitch"])])]);
    };
  }
};